<template>
	<div class="content">
		<div class="content-nr">
			<div class="banner">
				<Lunbo node="jjjs_lbt"></Lunbo>
			</div>
			<div class="tabLan">
				<tabLan :tabList="tabList" @setIndex="getIndex"></tabLan>
			</div>
			<div class="imgList">
				<div class="imgItem" v-if="contentTab == 0">
					<div class="itemBox">
						<div class="itemWB">
							<div class="item" v-for="item in imgList01">
								<router-link :to="{name:'fundDetail', query:{id:item.id}}">
								    <div>
								    	<img :src="item.title_img" alt="">
								    </div>
								</router-link>
								<div style="display: flex;align-items: center;">
									<div class="item-text">
										<span>{{item.title}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="fenye">
							<!-- hideOnSinglePage数据不足一页隐藏 -->
							<a-pagination
								v-model="page1" 
								:total="total1"
								@change="changePage1"
								show-less-items/>
						</div>
					</div>
				
				</div>
				<div class="imgItem" v-if="contentTab == 1">
					<div class="itemBox">
						<div class="itemWB">
							<div class="item" v-for="item in imgList02">
								<router-link :to="{name:'fundDetail', query:{id:item.id}}">
								    <div>
								    	<img :src="item.title_img" alt="">
								    </div>
								</router-link>
								<div style="display: flex;align-items: center;">
									<div class="item-text">
										<span>{{item.title}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="fenye">
							<a-pagination
								v-model="page2" 
								:total="total2"
								@change="changePage2"
								show-less-items/>
						</div>
					</div>
									
				</div>
				<div class="imgItem" v-if="contentTab == 2">
					<div class="itemBox">
						<div class="itemWB">
							<div class="item" v-for="item in imgList03">
								<router-link :to="{name:'fundDetail', query:{id:item.id}}">
								    <div>
								    	<img :src="item.title_img" alt="">
								    </div>
								</router-link>
								<div style="display: flex;align-items: center;">
									<div class="item-text">
										<span>{{item.title}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="fenye">
							<a-pagination
								v-model="page3" 
								:total="total3"
								@change="changePage3"
								show-less-items/>
						</div>
					</div>
									
				</div>
				<div class="imgItem" v-if="contentTab == 3">
					<div class="itemBox">
						<div class="itemWB">
							<div class="item" v-for="item in imgList04">
								<router-link :to="{name:'fundDetail', query:{id:item.id}}">
								    <div>
								    	<img :src="item.title_img" alt="">
								    </div>
								</router-link>
								<div style="display: flex;align-items: center;">
									<div class="item-text">
										<span>{{item.title}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="fenye">
							<a-pagination
								v-model="page4" 
								:total="total4"
								@change="changePage4"
								show-less-items/>
						</div>
					</div>
									
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Lunbo from "../../components/Lunbo.vue"
	import tabLan from "../../components/tabLan.vue"
	import apiUrls from "@/api";
	export default {
		components: {
			tabLan,
			Lunbo
		},
		data() {
			return {
				//当前页数
				page1: 1,
				page2: 1,
				page3: 1,
				page4: 1,
				//每页条数
				pageSize: 9,
				//总数
				total1: 0,
				total2: 0,
				total3: 0,
				total4: 0,
				
				flag: false,
				contentTab: 0,
				tabList: [
					{	
						text: '企业专项基金'
					},
					{
						text: '社区专项基金'
					},
					{
						text: '社会组织专项基金'
					},
					{
						text: '其他专项基金'
					}
				],
				imgList01: [],
				imgList02: [],
				imgList03: [],
				imgList04: [],
			}
		},
		mounted() {
			this.getImgList()
		},
		methods: {
			getIndex(index) {
				this.contentTab = index
				switch (index) {
				  case 0: 
				　　 this.getImgList()
				    break;
				  case 1: 
				　　this.getImgList2()
				    break;
				  case 2: 
				　　this.getImgList3()
				    break;
				  case 3:
				  　　this.getImgList4()
				      break;
				}
			},
			getImgList() {
				apiUrls.getList({ node: "jjjs_qyzxjj",page: this.page1-1, size: this.pageSize}).then(res => {
					// console.log(res.results)
					this.imgList01 = res.results.data
					this.total1 = res.results.pager.totalElements
				})
			},
			getImgList2() {
				apiUrls.getList({ node: "jjjs_sqzxjj",page: this.page2-1, size: this.pageSize}).then(res => {
					// console.log(res.results)
					this.imgList02 = res.results.data
					this.total2 = res.results.pager.totalElements
				})
			},
			getImgList3() {
				apiUrls.getList({ node: "jjjs_shzzzxjj",page: this.page3-1, size: this.pageSize}).then(res => {
					// console.log(res.results)
					this.imgList03 = res.results.data
					this.total3 = res.results.pager.totalElements
				})
			},
			getImgList4() {
				apiUrls.getList({ node: "jjjs_qtzxjj",page: this.page4-1, size: this.pageSize}).then(res => {
					// console.log(res.results)
					this.imgList04 = res.results.data
					this.total4 = res.results.pager.totalElements
				})
			},
			changePage1(page) {
				this.page1 = page;
				this.getImgList()
			},
			changePage2(page) {
				this.page2 = page;
				this.getImgList2()
			},
			changePage3(page) {
				this.page3 = page;
				this.getImgList3()
			},
			changePage4(page) {
				this.page4 = page;
				this.getImgList4()
			},
		}
	}
</script>

<style lang="less" scoped>
	.content {
		display: flex;
		justify-content: center;
		.content-nr {
			width: 1200px;
			.banner {
				width: 100%;
				height: 400px;
				margin-bottom: 20px;
				border: 1px solid #D8D8D8;
			}
			.tabLan {
				width: 100%;
				margin-bottom: 20px;
			}
			.imgList {
				width: 100%;
				// height: 1042px;
				min-height: 442px;
				margin-bottom: 60px;
				// position: relative;
				border: 1px solid #D8D8D8;
				.imgItem {
					width: 100%;
					height: 100%;
					position: relative;
					font-size: 70px;
					.itemBox {
						width: 100%;
						height: 100%;
					}
					.itemWB {
						// height: 930px;
						width: 100%;
						margin: 15px 0;
						display: flex;
						flex-wrap: wrap;
						justify-content: space-between;
						box-sizing: border-box;
						padding: 0 15px;
						&:after{
						  content:'';
						  /*这个宽度和子元素宽度一致*/
						  width: 375px;
						}
					}
					.fenye {
						width: 100%;
						height: 82px;
						display: flex;
						justify-content: flex-end;
						align-items: center;
						padding-right: 10px;
					}
					.item {
						width: 375px;
						height: 300px;
						margin-bottom: 10px;
						img {
							width: 375px;
							height: 249px;
						}
						.item-text {
							display: flex;
							flex-direction: column;
							justify-content: space-around;
							height: 31px;
							width: 100%;
						}
						span {
							width: 100%;
							font-size: 14px;
							font-weight: 700;
							color: #333333;
							font-family: "microsoft yahei";
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}
					}
				}
			}
		}
	}
</style>
